<template>
  <div>
    <Breadcrumbs
      main-link="welcome"
      :main="$t('dashboardVue.dashboard')"
      title=""
    />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div class="row">
        <div class="col-xl-8 ">
          <div v-if="page===null">
            <div class="alert alert-info">
              {{ $t('login.yklnir') }}
            </div>
          </div>
          <div
            v-else
            class="card"
          >
            <div class="card-body">
              <h4 class="card-title">
                {{ page.title }}
              </h4>

              <div
                class="lead page-text"
                v-html="page.text"
              />
            </div>
          </div>
        </div>
        <div class="col-xl-4 " />
      </div>
    </div>
    <!-- Container-fluid Ends-->
  </div>
</template>
<script>
import {mapState} from "vuex";
import {
  getPage,
} from "@/repositories/GeneralDataRepository";
import {mediaBase} from "@/repositories/Repository";

export default {
  data() {
    return {
      mediaBase: mediaBase,
      page: null
    }
  },
  computed: {
    ...mapState({
      token: state => state.auth.token,
      user: state => state.auth.user,
    }),


  },
  watch: {

    "$route"() {
      this.getPage();
    }
  },
  mounted() {

    this.getPage();

  },
  methods: {
    getPage() {
      getPage(this.token, this.$route.params['slug'], this.$i18n.locale).then(data => {
        if (data.code === 200) {

          this.page = data.data;

        } else {
          this.$swal({
            title: `Error ${data.code}`,
            text: `${data.message}`,
            icon: 'error'
          }).then(() => {
            window.location.reload();
          })
        }
      })
    }
  }

}
</script>
<style>
div.review canvas {
  position: relative !important;
}

div.review input {
  z-index: 1;
  display: inline-block;
}

.page-text ul, .page-text ol {
  list-style: square !important;
  margin-bottom: 20px !important;
  padding-left: 20px !important;
}

</style>
